<template>
  <div class="categories">
    <v-card-text>
      <v-row>

<v-col cols="sm-6" >
  <div class="row agency-row " v-for="val in items" :key="val.id">

    <div style='text-align: right' class="col-8 columns agency-col">
      <p style='margin-bottom: 15px;font-weight: bold;;font-size: 16px'>{{val.title}}</p>
      <h6 style='font-size:12px;margin-bottom: 3px;color:rgb(244, 67, 54);font-weight: 700;'>{{ $t('tavasot')}} : {{val.advertises_brand_title}}</h6>
      <h5 style='margin-bottom: 3px;font-size: 13px'>{{val.short_summary}}</h5>
      <strong v-if="val.price_status == '1'" style='font-weight: 500;color:#00B02F;font-size: 13px'>{{val.price.replace(/\B(?=(\d{3})+(?!\d))/g,
        ",")}} تومان </strong>

      <h6 v-if="val.advertises_accept_by_zoodkomak == 1" style='color:#00B02F;font-weight: 500;font-size: 13px'>
        <img src='/img/certificate.png' width='20px' height='20px'/> {{ $t('zemanatZoodkomak') }} </h6>
      <h6 v-else style='color:rgb(244, 67, 54);font-weight: 500;font-size: 13px'>{{ $t('barresiAgahi') }} </h6>

      <div style="padding:10px;" class="large-12 columns agency-col d-none d-sm-flex">
        <a v-if="val.post_request == 1" @click="add_request(val.id,val.cat_id, val.title)"
           class="agency-request-btn">{{val.post_types_title}}</a>

        <a v-if="val.post_request == 3" :href="'https://bilbordz.com/post/'+val.slug" target='_blank'
           class="agency-request-btn">{{ $t('showInfo') }}</a>
        <a v-if="val.post_request != 1 && val.post_request != 3" @click='post_view(val.slug)'
           target='_blank' class="agency-request-btn">{{ $t('showInfo') }}</a>
      </div>
    </div>

    <div style='text-align: left' class="col-4 columns  agency-col ">
      <img style='border-radius: 5px;width: 100%;height: auto;filter: invert("+val.filter_invert+");'
           :title="val.title" :src="val.post_image">
    </div>
    <div style="padding:10px;" class="large-12 columns agency-col d-flex d-sm-none">
      <a v-if="val.post_request == 1" @click="add_request(val.id,val.cat_id, val.title)"
         class="agency-request-btn">{{val.post_types_title}}</a>
      <a v-if="val.post_request == 3" :href="'https://bilbordz.com/post/'+val.slug" target='_blank'
         class="agency-request-btn">{{ $t('showInfo') }}</a>
      <a v-if="val.post_request != 1 && val.post_request != 3" @click='post_view(val.slug)'
         target='_blank' class="agency-request-btn">{{ $t('showInfo') }}</a>
    </div>

  </div>
</v-col>
        <v-col cols="12 col-sm-6" v-if="!isMobile">
          <img :src="'/img/agancy_side/'+language+'.webp'" style="padding: 40px;width:100%"/>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
  import MainBox from '../../components/MainBox'
  import zood_data from "./categories";

  export default {
    components: {
      MainBox
    },
    data() {
      return {
        language:process.env.VUE_APP_I18N_LOCALE,
        items: [],
        isMobile:false,
        selected_item_id: '',
        last_class_name: '',
        errors: [],
        rules: {
          required: value => !!value || 'necessary',
          fullName: value => value.length <= 30 || 'maxCharacter',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'nameNotFarsi'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    },
    watch: {},
    mounted() {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      console.log('posts passing_data',passing_data)

      this.selected_item_id = passing_data.group_id
      this.last_class_name = passing_data.class_id
      this.get_categories()
      window.addEventListener('resize', this.resize_mobile, { passive: true })
      this.resize_mobile()
    },
    methods: {
      resize_mobile() {
        if(window.innerWidth < 600) {
          this.isMobile= true
        } else {
          this.isMobile= false
        }
      },

      get_item_color(item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      add_request(id , cat_id,title){
        // if (this.dataset.post_id != null) {
          // localStorage.setItem("RequestPostId", id);
          // localStorage.setItem("RequestPostName", title);
          // localStorage.setItem("RequestPostBrand",cat_id);
          // window.open('/#AddRequest', "_self");
          // var passing_data = JSON.parse(localStorage.getItem('request_data'))
          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          // passing_data.sub_group_id = item_id
          // passing_data.request_name = passing_data.request_name + title + ' '
          passing_data.post_id =id
          passing_data.post_name =title
          passing_data.post_brand_id =cat_id

          localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({name: 'request_detail', params: {}})

        // this.$router.push({ path: 'brands', params: {} })

        // }
      },
      post_view(id) {
        window.open("https://bilbordz.com/api/view_post/" + id)
      },

      goToDetail(item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.group_id = item_id
        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({path: 'subgroups', params: {}})
      },
      get_categories() {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.sub_group_id

        const send_data = {
          groupId: cat_id,
        }
        var formData = new FormData()
        formData.append('groupId', cat_id)
        formData.append('language', this.language)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_group_posts', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.posts
              self.items.forEach(function (val) {

                if(self.language =='en'){
                  val.post_types_title = 'Request on-site service'
                }
                if(self.language =='ar'){
                  val.post_types_title = 'طلب خدمة في الموقع'
                }
                if(self.language =='tr'){
                  val.post_types_title = 'Yerinde hizmet talep edin'
                }
              })
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
<style>
  .agency-row {
    position: relative;
    margin-top: 5px !important;
    margin-left: 5px !important;
    margin-right: 5px !important;
    margin-bottom: 15px !important;
    -webkit-box-shadow: 0 10px 10px -5px;
    padding: 3px;
    text-align: center;
    display: flex;
    flex-wrap: wrap;

    box-shadow: 0 10px 10px -5px;
    border-radius: 6px;
    background: white;
    color: black;
  }

  .agency-col {
    padding-top: 0.5375em;
    padding-right: 0.5375em;
    padding-left: 0.5375em;
    padding-bottom: 0.5375em;
    /*align-self: center;*/
  }

  .agency-rate {
    margin-right: 5px;
    background: forestgreen;
    padding: 1px 5px;
    border-radius: 6px;
    color: white;
  }

  .agency-request-btn {
    padding: 8px 12px;
    color: white;
    background: hsl(210, 90%, 50%);
    border-radius: 6px;
    text-align: center;
    display: grid;
  }

  .agency-request-btn:hover {
    color: hsl(205, 74%, 80%);

  }

  .advertise {
    position: absolute;
    top: 3px;
    left: 3px;
    background: white;
    border-radius: 3px
  }

  .advertise-image {
    /*filter: invert(1);*/
    /*width:30px;*/
    /*height:30px;*/
  }

  @media only screen and (max-width: 768px) {
    .none-mobile {
      display: none !important;
    }

    .show-mobile {
      display: flex !important;
    }
  }

  @media only screen and (min-width: 769px) {
    .none-mobile {
      display: flex !important;
    }

    .show-mobile {
      display: none !important;
    }
  }

</style>
